import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import { useTemplateContext } from '../../context';
import { useCheckInformation } from '../../hooks/use-check-information';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTemplateItemBadgeProps as Props } from './types';

export const ExportTemplateItemBadge = memo(
  ({ className, checkedValues }: Props) => {
    const { information } = useTemplateContext();
    const checked = useCheckInformation(checkedValues, information);

    if (!!checked || !information) return null;

    return (
      <Styled.Wrapper
        className={classnames('ExportTemplateItemBadge', className)}
        sx={SX.root}
      >
        <Tooltip arrow placement="top" title={information.description}>
          <Icon name={information.icon} size={16} sxx={SX.icon} />
        </Tooltip>
      </Styled.Wrapper>
    );
  }
);

ExportTemplateItemBadge.displayName = 'ExportTemplateItemBadge';
